// Bolsas de comportamento que a tela edita, com os valores atuais da persona por cima dos padroes.
const PADRAO = {
  debounce: { enabled: true, windowSeconds: 8 },
  split: { enabled: true, maxChars: 300 },
  stt: { enabled: true },
  vision: { enabled: true },
  tts: { enabled: false },
  followUp: { enabled: false, steps: [] },
  memory: { compaction: { enabled: true } },
};

export const comportamentoInicial = settings =>
  Object.fromEntries(
    Object.entries(PADRAO).map(([chave, padrao]) => [
      chave,
      JSON.parse(JSON.stringify({ ...padrao, ...(settings[chave] || {}) })),
    ])
  );

export const podeEditar = (chave, plano) =>
  (plano?.settings_editaveis || []).includes(chave);
